import React, { useEffect, useState } from 'react';

const shapes = [
  { id: 1, cx: 100, cy: 150, r: 40, rotationSpeed: 20 },
  { id: 2, cx: 300, cy: 250, r: 60, rotationSpeed: -15 },
  { id: 3, cx: 500, cy: 100, r: 30, rotationSpeed: 30 },
  { id: 4, cx: 700, cy: 300, r: 50, rotationSpeed: -10 },
  // Add as many shapes as you want
];

export default function AnimatedBackground() {
  // Track mouse position as a normalized value [-1, 1]
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    function handleMouseMove(e) {
      const x = (e.clientX / window.innerWidth) * 2 - 1; // -1 to 1
      const y = (e.clientY / window.innerHeight) * 2 - 1; // -1 to 1
      setMousePos({ x, y });
    }
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <svg
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: -1,
      }}
      viewBox="0 0 800 400"
      preserveAspectRatio="xMidYMid meet"
    >
      {shapes.map(({ id, cx, cy, r, rotationSpeed }) => {
        // Calculate parallax offset (max ±20 px)
        const offsetX = mousePos.x * 20 * (id % 2 === 0 ? 1 : -1);
        const offsetY = mousePos.y * 20 * (id % 3 === 0 ? 1 : -1);

        // Inline style for rotation animation, duration based on rotationSpeed
        const rotationDuration = Math.abs(360 / rotationSpeed); // seconds per full rotation

        return (
          <circle
            key={id}
            cx={cx + offsetX}
            cy={cy + offsetY}
            r={r}
            fill="none"
            stroke="white"
            strokeOpacity="0.3"
            strokeWidth="2"
            style={{
              transformOrigin: `${cx + offsetX}px ${cy + offsetY}px`,
              animation: `rotateAnim ${rotationDuration}s linear infinite`,
              transformBox: 'fill-box',
            }}
          />
        );
      })}

      <style>
        {`
          @keyframes rotateAnim {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </svg>
  );
}
